<template>
  <div>
    <v-container grid-list-xl fluid>
      <v-layout>
        <v-flex xs3>
          <v-menu
            lazy
            :close-on-content-click="true"
            v-model="date_box"
            transition="scale-transition"
            offset-y
            full-width
            :nudge-right="40"
            max-width="290px"
            min-width="290px"
          >
            <v-text-field slot="activator" label="Date" v-model="date" persistent-hint readonly></v-text-field>
            <v-date-picker
              v-model="date"
              @input="date_box = false"
              @change="nextToCustomer"
              no-title
              actions
            ></v-date-picker>
          </v-menu>
        </v-flex>
        <v-flex xs3> <v-text-field
        v-model="search"
        append-icon="search"
        label="Search DO NUMBER"
        single-line
        hide-detailsf
      ></v-text-field>
    </v-flex>
      </v-layout>
    </v-container>
    <v-data-table
      :headers="headers"
      :items="stock"
      :search="search"
      disable-initial-sort
      class="elevation-1"
    >
      <template slot="items" slot-scope="props">
        <tr>
          <td>
            <v-avatar size="38">
              <img :src="(baseUrl+'/product/vege_img/'+props.item.product_image)" />
            </v-avatar>
          </td>
          <td class="text-xs-right">{{ props.item.product_name }}</td>
          <td class="text-xs-right">{{ props.item.grade }}</td>
          <td class="text-xs-right">{{ props.item.weight }}</td>
          <td class="text-xs-right">{{ props.item.quantity }}</td>
          <td class="text-xs-right">{{ props.item.price }}</td>
          <td class="text-xs-right">{{ props.item.grade }}</td>
          <td class="text-xs-right">{{ props.item.farmer_name }}</td>
          <td class="text-xs-right">{{ props.item.product_stocked_date }}</td>

          <td class="justify-end layout px-5">
            <v-icon medium color="error" @click="deleteItem(props.item)">delete_forever</v-icon>
          </td>
        </tr>
      </template>

      <v-alert
        slot="no-results"
        :value="true"
        color="primary"
        icon="warning"
      >Your search for "{{ search }}" found no results.</v-alert>
    </v-data-table>
    <v-snackbar v-model="snackbar" :top="true" :timeout="10000">
      No Internet Connection
      <v-btn color="pink" flat @click="snackbar = false">Close</v-btn>
    </v-snackbar>
    <v-snackbar v-model="snackbar_response" :bottom="true" :multi-line="true" :timeout="2500">
      {{response}}
      <v-btn color="primary" flat @click="snackbar_response = false">Close</v-btn>
    </v-snackbar>
  </div>
</template>
<script>
import axios from "axios";
import baseUrl from "@/api/baseurl";

export default {
    
  data: () => ({
    search: "",
    snackbar: false,
    dialog: false,
    errors: "",
    baseUrl: baseUrl,
    headers: [
      {
        text: "Image",
        value: "product_image"
      },

      { text: "Veg", align: "right", value: "product_name" },
      { text: "Grade", align: "right", value: "grade" },
      { text: "Weight", align: "right", value: "weight" },
      { text: "Qty", align: "right", value: "quantity" },
      { text: "RM", align: "right", value: "price" },
      { text: "Veg From", align: "right", value: "farmer_name" },
      { text: "Veg date", align: "right", value: "product_stocked_date" },
      { text: "Actions", align: "right", value: "id", sortable: false }
    ],
    stock: [],
    selected_farmer: "",
    selected_po_id: "",
    snackbar_response: false,
    response: "",
    type_need_weight: false
  }),

  computed: {},

  watch: {
    dialog(val) {
      val || this.close();
    }
  },

  created() {},

  methods: {
    getDOStock: function(do_id) {
      const params = new URLSearchParams();

      params.append("getDOStock", "getDOStock");
      params.append("do_id", do_id);
      axios({
        method: "post",
        url: baseUrl + "/vege_web_v2/stock/delivery_order.php",
        data: params
      })
        .then(response => {
          if (response.data.error == false) {
            this.stock = response.data.data;
          } else if (response.data.error == true) {
            this.errors = response.data.message;
            this.stock = [];
            setTimeout(
              function() {
                this.errors = "";
              }.bind(this),
              6000
            );
          }
        })
        .catch(error => {
          console.log(error);
          this.snackbar = true;
        });
    },

    deleteItem(item) {
      const params = new URLSearchParams();
      params.append("deleteDOStock", "deleteDOStock");
      params.append("id", item.id);

      axios({
        method: "post",
        url: baseUrl + "/vege_web_v2/stock/delivery_order.php",
        data: params
      })
        .then(response => {
          if (response.data.error == false) {
            this.getPOStock(this.selected_po_id, this.selected_farmer);
            this.snackbar_response = true;
            this.response = response.data.data;
          } else if (response.data.error == true) {
            this.errors = response.data.message;
            this.snackbar_response = true;
            this.response = response.data.data;
            setTimeout(
              function() {
                this.errors = "";
              }.bind(this),
              6000
            );
          }
        })
        .catch(error => {
          console.log(error);
          this.snackbar = true;
        });
    }
  }
};
</script>

